// AdminContent — Content moderation queue (posts, comments, messages)

import { useState } from 'react';

interface Report {
  id: string; type: 'post' | 'comment' | 'message' | 'bot' | 'profile';
  content: string; author: string; reason: string; reportedBy: string;
  time: string; severity: 'low' | 'medium' | 'high';
}

const REPORTS: Report[] = [
  { id: 'r1', type: 'post',    content: 'Just hit a $10K day on the bot! Try my "secret" strategy → scam-site.com 🚀',           author: 'fakeuser123',     reason: 'Spam / External link', reportedBy: '@user1', time: '12m ago', severity: 'high' },
  { id: 'r2', type: 'comment', content: 'You\'re an idiot, this market will obviously crash. Stop giving bad advice.',           author: 'angry-trader',    reason: 'Harassment',           reportedBy: '@marcus', time: '2h ago',  severity: 'medium' },
  { id: 'r3', type: 'message', content: 'Hey, want to share my broker account for some insider trades?',                       author: 'suspicious42',    reason: 'Account sharing',     reportedBy: '@sofia',  time: '4h ago',  severity: 'high' },
  { id: 'r4', type: 'bot',     content: 'My bot guarantees 90% win rate! Risk-free!',                                        author: 'scammer',         reason: 'Misleading claims',   reportedBy: '@brandon',time: '6h ago',  severity: 'high' },
  { id: 'r5', type: 'profile', content: 'Profile uses celebrity name + photo',                                              author: 'fakeelon',        reason: 'Impersonation',       reportedBy: '@aiden',  time: '1d ago',  severity: 'medium' },
];

const SEV_META = { low: { color: '#34C759', label: 'Low' }, medium: { color: '#FF9500', label: 'Med' }, high: { color: '#FF3B30', label: 'High' } };
const TYPE_META = { post: '📝', comment: '💬', message: '✉️', bot: '🤖', profile: '👤' };

export function AdminContent() {
  const [items, setItems] = useState(REPORTS);
  const [filter, setFilter] = useState<'all' | 'high' | 'medium' | 'low'>('all');

  const filtered = items.filter((r) => filter === 'all' || r.severity === filter);

  function dismiss(id: string) { if (confirm('Dismiss this report?')) { setItems((c) => c.filter((r) => r.id !== id)); alert('Dismissed.'); } }
  function remove(id: string) { if (confirm('Remove this content?')) { setItems((c) => c.filter((r) => r.id !== id)); alert('Content removed. Author notified.'); } }
  function ban(id: string, author: string) { if (confirm(`Ban ${author}?`)) { setItems((c) => c.filter((r) => r.id !== id)); alert(`${author} banned.`); } }
  function shadow(id: string) { setItems((c) => c.filter((r) => r.id !== id)); alert('Content shadow-hidden (only author can see it).'); }

  return (
    <div className="space-y-4 max-w-5xl mx-auto">
      <div>
        <h1 className="text-[22px] font-bold text-white">Content moderation</h1>
        <p className="text-[12px] text-white/50">{items.length} reports · {items.filter((r) => r.severity === 'high').length} high severity</p>
      </div>

      <div className="flex items-center gap-1.5">
        {(['all', 'high', 'medium', 'low'] as const).map((f) => (
          <button key={f} onClick={() => setFilter(f)} data-testid={`contfilter-${f}`} className={['rounded-full px-3 py-1.5 text-[12px] font-semibold capitalize transition', filter === f ? 'bg-white text-black' : 'bg-white/5 text-white/60 active:bg-white/10'].join(' ')}>
            {f}
          </button>
        ))}
      </div>

      <div className="space-y-2">
        {filtered.map((r) => {
          const s = SEV_META[r.severity];
          return (
            <div key={r.id} data-testid={`report-${r.id}`} className="rounded-[16px] bg-[#1C1C1E] border border-white/5 p-4">
              <div className="flex items-start gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-[12px] bg-white/5 text-[18px]">{TYPE_META[r.type]}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-[12px] font-bold text-white">{r.author}</span>
                    <span className="rounded-full bg-white/5 px-1.5 py-0.5 text-[9px] font-semibold uppercase text-white/60">{r.type}</span>
                    <span className="rounded-full px-1.5 py-0.5 text-[9px] font-bold uppercase" style={{ backgroundColor: s.color + '20', color: s.color }}>{s.label}</span>
                    <span className="text-[10px] text-white/40">{r.time}</span>
                  </div>
                  <p className="text-[13px] text-white">"{r.content}"</p>
                  <div className="mt-1.5 text-[11px] text-white/50">Reason: <span className="text-white">{r.reason}</span> · Reported by {r.reportedBy}</div>
                </div>
                <div className="flex flex-col gap-1.5 shrink-0">
                  <button onClick={() => remove(r.id)} data-testid={`remove-${r.id}`} className="h-8 rounded-full bg-[#FF3B30] px-3 text-[11px] font-semibold text-white active:opacity-40">Remove</button>
                  <button onClick={() => shadow(r.id)} data-testid={`shadow-${r.id}`} className="h-8 rounded-full bg-[#FF9500] px-3 text-[11px] font-semibold text-white active:opacity-40">Shadow</button>
                  <button onClick={() => ban(r.id, r.author)} data-testid={`banuser-${r.id}`} className="h-8 rounded-full bg-white/5 px-3 text-[11px] font-semibold text-white active:bg-white/10">Ban user</button>
                  <button onClick={() => dismiss(r.id)} data-testid={`dismiss-${r.id}`} className="h-8 rounded-full bg-white/5 px-3 text-[11px] font-semibold text-white/60 active:bg-white/10">Dismiss</button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
